import { ApplicationView } from "@mixitone/mvc";
import { twMerge } from "tailwind-merge";
import SpinnerSvg from "@mixitone/icons/spinner.svg";

export const Spinner = ApplicationView(({ size, className }: { size: number; className?: string }) => {
  return (
    <SpinnerSvg
      className={twMerge("animate-spin fill-black", className)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
});
